<div class="flex-row-container m-t5">
  <span class="flex-1 m-t10 m-l15 blueText16 B">Goal Expenses</span>
  <!-- <button mat-stroked-button class="m-r10" color="primary">Save</button> -->
  <button mat-stroked-button class="m-r10" color="primary" [ngClass]="isDataChanged?'highlight-bg':''" (click)="saveSelectedExpenses($event)">Save</button>
  <button class="m-r10 font14" disabled mat-stroked-button color="primary" (click)="$event.stopPropagation();">Add Expense</button>
  <!-- <button [matMenuTriggerFor]="expensemenu" class="m-r10 font14" mat-stroked-button color="primary" (click)="$event.stopPropagation();">Add Expense</button> -->
</div>
<div class="flex-row-center m-t8">
  <mat-divider class="divider" style="width: 99%"></mat-divider>
</div>
<div class="summary-panel-container" (click)="$event.stopPropagation();">
  <mat-card *ngFor="let exp of expenses" class="summary-item pointer" [matBadge]="exp.isIncluded?'check':''" [style.background]="exp.isIncluded?'#D5D7F2':''" (click)="selectExpense(exp.expId)">
  <!-- <mat-card *ngFor="let exp of expenses" class="summary-item pointer" [matBadge]="exp.isIncluded?'check':''" [style.background]="exp.isIncluded?'#D5D7F2':''"> -->
    <mat-card-content> 
      <div class="flex-col-container">
        <span class="blueText20 text-truncate">{{exp.expDesc}}</span>        
      </div>
        <div class="flex-row-container m-t3">
          <div class="flex-col-container wd-60">
            <span class="font14">({{exp.expTypeDesc}})</span>            
            <span class="font15">{{exp.start}} - {{exp.end}}</span>  
            <!-- <span class="font18">{{exp.ownerName}}</span> -->
            <!-- <span class="font15 text-truncate">Annual Inflation: {{inc.growthType==='INF'?'Inflation 2.0': inc.growthRate}}%</span> -->
          </div>
          <div class="flex-col-end m-l25 wd-40">            
            <span class="blueText22">{{exp.amount | currency:'USD': 'symbol' : '1.0-0'}}</span>
            <span class="font14 gray-text">per {{exp.isMonthly?'month':'year'}}</span>            
            <div class="flex-row-container">
              <mat-icon class="font20 m-l10" (click)="editExpense(exp.expId);$event.stopPropagation();">edit</mat-icon>  
              <mat-icon class="font20 m-l10 pointer" (click)="deleteExpense(exp.expId, exp.expDesc);$event.stopPropagation();">delete</mat-icon>
              <!-- <mat-icon class="font30" *ngIf="acc.selected">check</mat-icon>               -->
            </div>
            <!-- <span class="blueText14">LegalEntityName</span>
            <span class="font14 gray-text text-truncate">Individual</span> -->
          </div>          
          <!-- <div class="m-l15 flex-col-container">
            <span class="font16"></span>
            <span class="font16">Managed</span>
            <span class="blueText14">Advisor Model</span>
            <span class="font14 gray-text text-truncate">Global Equity Model</span>
          </div> -->
        </div>
        <!-- <div class="m-t10 flex-row-container">
          <div class="flex-col-container">
            <span class="font16">TAX-DEFERRED</span>            
          </div>
          <div class="m-l15  flex-col-container">
            <span class="font16">$869,596</span>            
          </div>
        </div> -->
        <!-- <div class="flex-row-center">          
        </div> -->
    </mat-card-content>
  </mat-card>
</div>

<mat-menu #expensemenu="matMenu">
  <ng-container *ngFor="let item of expenseTypeMenuItems">
    <button class="font14" mat-menu-item (click)="addExpense(item.code);$event.stopPropagation();"> {{item.value}}</button>    
  </ng-container> 
</mat-menu>

